var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FCC331"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22838 11.6743H8.26838L8.01838 6.7643H9.47838L9.22838 11.6743ZM7.97838 13.2643C7.97838 12.9843 8.05171 12.7876 8.19838 12.6743C8.34505 12.5543 8.52838 12.4943 8.74838 12.4943C8.94838 12.4943 9.12505 12.5543 9.27838 12.6743C9.43171 12.7876 9.50838 12.9843 9.50838 13.2643C9.50838 13.5376 9.43171 13.7343 9.27838 13.8543C9.12505 13.9743 8.94838 14.0343 8.74838 14.0343C8.52838 14.0343 8.34505 13.9743 8.19838 13.8543C8.05171 13.7343 7.97838 13.5376 7.97838 13.2643ZM11.7311 11.6743H10.7711L10.5211 6.7643H11.9811L11.7311 11.6743ZM10.4811 13.2643C10.4811 12.9843 10.5544 12.7876 10.7011 12.6743C10.8478 12.5543 11.0311 12.4943 11.2511 12.4943C11.4511 12.4943 11.6278 12.5543 11.7811 12.6743C11.9344 12.7876 12.0111 12.9843 12.0111 13.2643C12.0111 13.5376 11.9344 13.7343 11.7811 13.8543C11.6278 13.9743 11.4511 14.0343 11.2511 14.0343C11.0311 14.0343 10.8478 13.9743 10.7011 13.8543C10.5544 13.7343 10.4811 13.5376 10.4811 13.2643Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityMedium);
export default __webpack_public_path__ + "static/media/priority-medium.7d10bffd85d8c2bf4564f1ebc5a0684b.svg";
export { ForwardRef as ReactComponent };